const pageNameKey = "otaRequestForApproval";

export const otaRequestForApprovalEn = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName} Request for Approval",
    titleTemplateBackup: "Backup {itemName} Request for Approval",
    descriptionTemplateFirmware:
      "The Technician {initiator} requests to push a new firmware to this machine.",
    descriptionTemplateBackup:
      "The Technician {initiator} requests to push a new backup to this machine.",
    reviewAndApproveButtonText: "Review Request and Approve",
  },
};

export const otaRequestForApprovalPtBr = {
  [pageNameKey]: {
    titleTemplateFirmware: "Solicitacao de aprovacao do firmware {itemName}",
    titleTemplateBackup: "Solicitacao de aprovacao do backup {itemName}",
    descriptionTemplateFirmware:
      "O tecnico {initiator} solicita enviar um novo firmware para esta maquina.",
    descriptionTemplateBackup:
      "O tecnico {initiator} solicita enviar um novo backup para esta maquina.",
    reviewAndApproveButtonText: "Revisar solicitacao e aprovar",
  },
};

export const otaRequestForApprovalDe = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: Anfrage zur Genehmigung",
    titleTemplateBackup: "Backup {itemName}: Anfrage zur Genehmigung",
    descriptionTemplateFirmware:
      "Der Techniker {initiator} beantragt, eine neue Firmware auf diese Maschine zu uebertragen.",
    descriptionTemplateBackup:
      "Der Techniker {initiator} beantragt, ein neues Backup auf diese Maschine zu uebertragen.",
    reviewAndApproveButtonText: "Anfrage pruefen und genehmigen",
  },
};

export const otaRequestForApprovalZhHans = {
  [pageNameKey]: {
    titleTemplateFirmware: "固件 {itemName} 请求批准",
    titleTemplateBackup: "备份 {itemName} 请求批准",
    descriptionTemplateFirmware:
      "技术人员 {initiator} 请求向此机器推送新的固件。",
    descriptionTemplateBackup: "技术人员 {initiator} 请求向此机器推送新的备份。",
    reviewAndApproveButtonText: "审核并批准请求",
  },
};

export const otaRequestForApprovalIt = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: richiesta di approvazione",
    titleTemplateBackup: "Backup {itemName}: richiesta di approvazione",
    descriptionTemplateFirmware:
      "Il tecnico {initiator} richiede di inviare un nuovo firmware a questa macchina.",
    descriptionTemplateBackup:
      "Il tecnico {initiator} richiede di inviare un nuovo backup a questa macchina.",
    reviewAndApproveButtonText: "Rivedi richiesta e approva",
  },
};

export const otaRequestForApprovalEs = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: solicitud de aprobacion",
    titleTemplateBackup: "Respaldo {itemName}: solicitud de aprobacion",
    descriptionTemplateFirmware:
      "El tecnico {initiator} solicita enviar un nuevo firmware a esta maquina.",
    descriptionTemplateBackup:
      "El tecnico {initiator} solicita enviar un nuevo respaldo a esta maquina.",
    reviewAndApproveButtonText: "Revisar solicitud y aprobar",
  },
};

export const otaRequestForApprovalNl = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName}: verzoek om goedkeuring",
    titleTemplateBackup: "Back-up {itemName}: verzoek om goedkeuring",
    descriptionTemplateFirmware:
      "De technicus {initiator} vraagt om nieuwe firmware naar deze machine te pushen.",
    descriptionTemplateBackup:
      "De technicus {initiator} vraagt om een nieuwe back-up naar deze machine te pushen.",
    reviewAndApproveButtonText: "Verzoek beoordelen en goedkeuren",
  },
};

export const otaRequestForApprovalTr = {
  [pageNameKey]: {
    titleTemplateFirmware: "Firmware {itemName} Onay Talebi",
    titleTemplateBackup: "Yedekleme {itemName} Onay Talebi",
    descriptionTemplateFirmware:
      "Teknisyen {initiator} bu makineye yeni bir ürün yazılımı aktarmayı talep ediyor.",
    descriptionTemplateBackup:
      "Teknisyen {initiator} bu makineye yeni bir yedek göndermeyi talep ediyor.",
    reviewAndApproveButtonText: "İsteği İncele ve Onayla",
  },
};
